<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <progress-components page="confirm"></progress-components>
      <v-card
        class="mx-1 mt-6 px-5"
        elevation="5"
        outlined
      >
        <v-card-title>
          <strong>基本情報</strong>
        </v-card-title>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              氏名<span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ name }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              フリガナ<span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ kana }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              年齢属性<span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ age }}
          </v-col>
        </v-row>
        <div v-show="age === '13歳以上18歳未満'">
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              保護者の名前<span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ nameOfParent }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              保護者の電話番号<span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ telOfParent }}
          </v-col>
        </v-row>
        </div>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              証明証各種
            </v-alert>
          </v-col>
        </v-row>
        <v-row v-for="(item, index) in certificates" :key="`certificates_${index}`"
              no-gutters justify="start" align-content="center">
          <v-col v-if="item == 'その他'" align="start" class="ml-4">
            {{ item }}: {{ causesOfOtherRisk }}
          </v-col>
          <v-col v-else align="start" class="ml-4">
            {{ item }}
          </v-col>
        </v-row>
        <v-row justify="center" align-content="center" class="my-5 btn-area">
          <v-btn
            dark
            color="doorAccentColor"
            x-large min-width="362px" class="mb-4 mx-4"
            @click="returnUserInfo"
          >編集
          </v-btn>
        </v-row>
      </v-card>
      <v-card
        class="mx-1 mt-6 px-5"
        elevation="5"
        outlined
      >
        <v-card-title>
          <strong>重症化リスク</strong>
        </v-card-title>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              重症化リスク要因_既往歴<span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ hasDuringTreatment }}
          </v-col>
        </v-row>
        <div v-show="hasDuringTreatment == '有'">
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                重症化リスク要因_既往歴(病名)
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in riskOfSerious" :key="`certificates_${index}`"
                no-gutters justify="start" align-content="center">
            <v-col v-if="item == 'その他'" align="start" class="ml-4">
              {{ item }}: {{ riskOfSeriousOther }}
            </v-col>
            <v-col v-else align="start" class="ml-4">
              {{ item }}
            </v-col>
          </v-row>
        </div>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              重症化リスク要因_肥満(BMI30以上) <span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ obesityRisk }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              重症化リスク要因_妊娠 <span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ pregnancyRisk }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              重症化リスク要因_喫煙歴 <span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ smokingRisk }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              重症化リスク要因_その他 <span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ otherRisk }}
          </v-col>
        </v-row>
        <v-row justify="center" align-content="center" class="my-5 btn-area">
          <v-btn
            dark
            color="doorAccentColor"
            x-large min-width="362px" class="mb-4 mx-4"
            @click="returnRisk"
          >編集
          </v-btn>
        </v-row>
      </v-card>
      <v-card
        class="mx-1 mt-6 px-5"
        elevation="5"
        outlined
      >
        <v-card-title>
          <strong>問診</strong>
        </v-card-title>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              検査_検体採取日 <span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ inspectionDate }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              新型コロナウイルスワクチン_接種歴  <span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ vaccinationHistory }}
          </v-col>
        </v-row>

        <div v-show="vaccinationHistory !== '0回' && vaccinationHistory !== '不明'">
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                新型コロナウイルスワクチン_直近接種年月日 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ coronaVaccinationDate }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                新型コロナウイルスワクチン_直近接種 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ coronaVaccineName }}
            </v-col>
          </v-row>
        </div>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              インフルエンザワクチン_1年以内の接種歴  <span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ fluVaccinationHistory }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              症状の有無 <span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ symptoms }}
          </v-col>
        </v-row>
        <div v-show="symptoms === '有'">
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_発生した日 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ dateOfOnset }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_発熱 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ fever }}
            </v-col>
          </v-row>
          <div v-show="fever === '37.5度以上'">
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_発熱時の体温 <span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ feverNum }}度
              </v-col>
            </v-row>
          </div>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_せき<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ cough }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_せき以外の呼吸器症状<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ otherThanCough }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_倦怠感<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ senseOfFatigue }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_頭痛<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ headache }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_嘔気/嘔吐<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ nausea }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_下痢<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ diarrhea }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_結膜炎<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ conjunctivitis }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状_咽頭痛<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ pharyngitis }}
            </v-col>
          </v-row>
        </div>
        <v-row justify="center" align-content="center" class="my-5 btn-area">
          <v-btn
            dark
            color="doorAccentColor"
            x-large min-width="362px" class="mb-4 mx-4"
            @click="returnMedical"
          >編集
          </v-btn>
        </v-row>
      </v-card>
      <v-card
        class="mx-1 mt-6 px-5"
        elevation="5"
        outlined
      >
        <v-card-title>
          <strong>濃厚接触</strong>
        </v-card-title>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              感染の可能性_インフルエンザ患者の方との接触または身近での流行<span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ fulPatientContact }}
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center" class="mt-4">
          <v-col align="start">
            <v-alert
              class="py-1 mt-4 rounded-0 font-weight-bold"
              border="left"
              colored-border
            >
              感染の可能性_新型コロナウイルス患者の方との接触または身近での流行<span class="text-red"><strong> *</strong></span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row no-gutters justify="start" align-content="center">
          <v-col align="start" class="ml-4">
            {{ coronaPatientContact }}
          </v-col>
        </v-row>
        <div v-show="hasIntensiveContact === '有'">
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                感染の可能性_濃厚接触者② <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in causeIntensiveContact" :key="`causeIntensiveContact_${index}`"
                no-gutters justify="start" align-content="center">
            <v-col v-if="item == 'その他'" align="start" class="ml-4">
              {{ item }}: {{ causeIntensiveContactOther }}
            </v-col>
            <v-col v-else align="start" class="ml-4">
              {{ item }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                感染の可能性_感染した可能性のある場所<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
        </div>
        <v-row v-for="(item, index) in placeIntensiveContact" :key="`placeIntensiveContact${index}`"
              no-gutters justify="start" align-content="center">
          <v-col v-if="item == 'その他'" align="start" class="ml-4">
            {{ item }}: {{ placeIntensiveContactOther }}
          </v-col>
          <v-col v-else align="start" class="ml-4">
            {{ item }}
          </v-col>
        </v-row>
        <v-row justify="center" align-content="center" class="my-5 btn-area">
          <v-btn
            dark
            color="doorAccentColor"
            x-large min-width="362px" class="mb-4 mx-4"
            @click="returnContact"
          >編集
          </v-btn>
        </v-row>
      </v-card>
    </v-container>
    <v-container class="mx-auto mt-8">
      <v-row justify="center" align-content="center" class="mb-6">
        <v-col align="center"><span class="text-lg-h6 font-weight-bold red--text">こちらの内容でよろしければ「送信」を押してください。</span>
        </v-col>
      </v-row>
      <v-row justify="center" align-content="center" class="mb-6 send-btn-area">
        <v-btn
          :disabled="isDisableSendBtn"
          dark
          x-large min-width="400px"
          color="success"
          class="mb-4 mx-4"
          @click="clickedSubmit"
        >送信
        </v-btn>
      </v-row>
    </v-container>
    <error-dialog :isOpen="isError"></error-dialog>
    <footer-components></footer-components>
  </v-main>
</template>
<script>
import { defineComponent, computed, onMounted, ref } from 'vue'
import { Logger } from 'aws-amplify'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import ProgressComponents from '@/components/InterviewProgress.vue'
import ErrorDialog from '@/components/ErrorDialog.vue'
import { DuplicateError } from '@/errors/DuplicateError'
import { useScreenOperation } from '@/func/useScreenOperation'
import { useRequestConverter } from '@/func/useRequestConverter'

const logger = new Logger('AdvanceForm');

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
    'progress-components': ProgressComponents,
    'error-dialog': ErrorDialog
  },
  setup() {
    logger.info('Advance confirm')
    const { scrollToTop, toErrorIfNotExistsId } = useScreenOperation()
    onMounted(() => {
      scrollToTop()
      toErrorIfNotExistsId()
    })
    const store = useStore()
    const router = useRouter()

    const name = computed(() => store.state.advanceInterview.name)
    const kana = computed(() => store.state.advanceInterview.kana)
    const age = computed(() => store.state.advanceInterview.age)
    const otherAge = computed(() => store.state.advanceInterview.otherAge)
    const nameOfParent = computed(() => store.state.advanceInterview.nameOfParent)
    const telOfParent = computed(() => store.state.advanceInterview.telOfParent)
    const certificates = computed(() => store.state.advanceInterview.certificates)

    // 重症化リスク
    const hasDuringTreatment = computed(() => store.state.advanceInterview.hasDuringTreatment)
    const riskOfSerious = computed(() => store.state.advanceInterview.riskOfSerious)
    const riskOfSeriousOther = computed(() => store.state.advanceInterview.riskOfSeriousOther)
    const obesityRisk = computed(() => store.state.advanceInterview.obesityRisk)
    const pregnancyRisk = computed(() => store.state.advanceInterview.pregnancyRisk)
    const smokingRisk = computed(() => store.state.advanceInterview.smokingRisk)
    const otherRisk = computed(() => store.state.advanceInterview.otherRisk)

    //問診
    const inspectionDate = computed(() => store.state.advanceInterview.inspectionDate)
    const kitName = computed(() => store.state.advanceInterview.kitName)
    const searchMethod = computed(() => store.state.advanceInterview.searchMethod)
    const searchOtherMethod = computed(() => store.state.advanceInterview.searchOtherMethod)
    const vaccinationHistory = computed(() => store.state.advanceInterview.vaccinationHistory)
    const coronaVaccinationDate = computed(() => store.state.advanceInterview.coronaVaccinationDate)
    const coronaVaccineName = computed(() => store.state.advanceInterview.coronaVaccineName)
    const fluVaccinationHistory = computed(() => store.state.advanceInterview.fluVaccinationHistory)
    const symptoms = computed(() => store.state.advanceInterview.symptoms)
    const dateOfOnset = computed(() => store.state.advanceInterview.dateOfOnset)
    const fever = computed(() => store.state.advanceInterview.fever)
    const feverNum = computed(() => store.state.advanceInterview.feverNum)
    const cough = computed(() => store.state.advanceInterview.cough)
    const otherThanCough = computed(() => store.state.advanceInterview.otherThanCough)
    const senseOfFatigue = computed(() => store.state.advanceInterview.senseOfFatigue)
    const headache = computed(() => store.state.advanceInterview.headache)
    const nausea = computed(() => store.state.advanceInterview.nausea)
    const diarrhea = computed(() => store.state.advanceInterview.diarrhea)
    const conjunctivitis = computed(() => store.state.advanceInterview.conjunctivitis)
    const pharyngitis = computed(() => store.state.advanceInterview.pharyngitis)

    //渡航歴
    const travelHistory = computed(() => store.state.advanceInterview.travelHistory)
    const departureDate = computed(() => store.state.advanceInterview.departureDate)
    const entryDate = computed(() => store.state.advanceInterview.entryDate)
    const destination = computed(() => store.state.advanceInterview.destination)

    //濃厚接触
    const fulPatientContact = computed(() => store.state.advanceInterview.fulPatientContact)
    const coronaPatientContact = computed(() => store.state.advanceInterview.coronaPatientContact)
    const hasIntensiveContact = computed(() => store.state.advanceInterview.hasIntensiveContact)
    const causeIntensiveContact = computed(() => store.state.advanceInterview.causeIntensiveContact)
    const causeIntensiveContactOther = computed(() => store.state.advanceInterview.causeIntensiveContactOther)
    const placeIntensiveContact = computed(() => store.state.advanceInterview.placeIntensiveContact)
    const placeIntensiveContactOther = computed(() => store.state.advanceInterview.placeIntensiveContactOther)

    // 送信ボタン非活性フラグ
    const isDisableSendBtn = ref(false)
    const errorDialog = ref(false)
    const isError = computed(() => errorDialog)

    const returnUserInfo = () => router.push('/interview?from=confirm')
    const returnRisk = () => router.push('/interview/risk?from=confirm')
    const returnMedical = () => router.push('/interview/medical?from=confirm')
    const returnTravel = () => router.push('/interview/travel?from=confirm')
    const returnContact = () => router.push('/interview/contact?from=confirm')

    const interviewError = computed({
      get: () => store.getters['requestError/interviewError'],
      set: (value) => store.dispatch('requestError/setInterviewError', value)
    })

    const { toUserInfoByState, toRiskOfSeriousByState, toMedicalInterviewByState, toTravelHistoryByState, toIntensiveContactByState } = useRequestConverter()
    const clickedSubmit = async () => {
      isDisableSendBtn.value = true
      try {
        await store.dispatch('advanceInterview/processInterviewAnswer', {
          jwtToken: store.state.apiParams.jwtToken,
          treatmentConsultationSeq: store.state.apiParams.treatmentConsultationSeq,
          treatmentSerialNumber: store.state.apiParams.treatmentSerialNumber,
          userInfo: toUserInfoByState(store),
          riskOfSerious: toRiskOfSeriousByState(store),
          interview: toMedicalInterviewByState(store),
          travelHistory: toTravelHistoryByState(store),
          intensiveContact:  toIntensiveContactByState(store),
          statusCode: 0,
          interviewError: interviewError.value
        })
        interviewError.value = false
        await router.push('/interview/done')
      } catch (e) {
        if (!(e instanceof DuplicateError)) interviewError.value = true
        isDisableSendBtn.value = false
        errorDialog.value = true
        logger.error(e)
      }
    }
    return {
      age,
      otherAge,
      name,
      kana,
      nameOfParent,
      telOfParent,
      certificates,
      kitName,
      riskOfSerious,
      riskOfSeriousOther,
      obesityRisk,
      pregnancyRisk,
      smokingRisk,
      otherRisk,
      inspectionDate,
      searchMethod,
      vaccinationHistory,
      coronaVaccinationDate,
      coronaVaccineName,
      fluVaccinationHistory,
      symptoms,
      dateOfOnset,
      fever,
      cough,
      otherThanCough,
      senseOfFatigue,
      headache,
      nausea,
      diarrhea,
      pharyngitis,
      conjunctivitis,
      travelHistory,
      departureDate,
      entryDate,
      destination,
      fulPatientContact,
      coronaPatientContact,
      hasIntensiveContact,
      causeIntensiveContact,
      causeIntensiveContactOther,
      placeIntensiveContact,
      placeIntensiveContactOther,
      returnUserInfo,
      returnRisk,
      returnMedical,
      returnTravel,
      returnContact,
      clickedSubmit,
      hasDuringTreatment,
      isDisableSendBtn,
      errorDialog,
      isError,
      feverNum,
      searchOtherMethod
    }
  }
})
</script>

<style scoped>
.multi-line-text {
  white-space: pre-line;
  word-wrap: break-word;
}

@media screen and (max-width: 960px) {
  .btn-area button{
    min-width: 70%!important;
  }
  .send-btn-area button{
    min-width: 70%!important;
  }
}
</style>
